/**
 * Länderliste für Investment-CRM (ISO 3166-1 alpha-2).
 * - Anforderungsprofil: Multi-Select aus dieser Liste (Investor kann viele Länder).
 * - Verkaufsmandat: Single-Select aus dieser Liste (genau 1 Land, wird gematcht).
 */
export interface Country { code: string; label: string; }

export const COUNTRIES: Country[] = [
  // DACH
  { code: 'DE', label: 'Deutschland' },
  { code: 'AT', label: 'Österreich' },
  { code: 'CH', label: 'Schweiz' },
  { code: 'LI', label: 'Liechtenstein' },
  // West-/Nordeuropa
  { code: 'NL', label: 'Niederlande' },
  { code: 'BE', label: 'Belgien' },
  { code: 'LU', label: 'Luxemburg' },
  { code: 'FR', label: 'Frankreich' },
  { code: 'GB', label: 'Vereinigtes Königreich' },
  { code: 'IE', label: 'Irland' },
  { code: 'DK', label: 'Dänemark' },
  { code: 'SE', label: 'Schweden' },
  { code: 'NO', label: 'Norwegen' },
  { code: 'FI', label: 'Finnland' },
  { code: 'IS', label: 'Island' },
  // Süd-/Osteuropa
  { code: 'ES', label: 'Spanien' },
  { code: 'PT', label: 'Portugal' },
  { code: 'IT', label: 'Italien' },
  { code: 'GR', label: 'Griechenland' },
  { code: 'MT', label: 'Malta' },
  { code: 'CY', label: 'Zypern' },
  { code: 'PL', label: 'Polen' },
  { code: 'CZ', label: 'Tschechien' },
  { code: 'SK', label: 'Slowakei' },
  { code: 'HU', label: 'Ungarn' },
  { code: 'SI', label: 'Slowenien' },
  { code: 'HR', label: 'Kroatien' },
  { code: 'RO', label: 'Rumänien' },
  { code: 'BG', label: 'Bulgarien' },
  { code: 'EE', label: 'Estland' },
  { code: 'LV', label: 'Lettland' },
  { code: 'LT', label: 'Litauen' },
  { code: 'RS', label: 'Serbien' },
  // Amerika
  { code: 'US', label: 'USA' },
  { code: 'CA', label: 'Kanada' },
  { code: 'MX', label: 'Mexiko' },
  { code: 'BR', label: 'Brasilien' },
  // APAC
  { code: 'JP', label: 'Japan' },
  { code: 'CN', label: 'China' },
  { code: 'HK', label: 'Hongkong' },
  { code: 'SG', label: 'Singapur' },
  { code: 'KR', label: 'Südkorea' },
  { code: 'AU', label: 'Australien' },
  { code: 'NZ', label: 'Neuseeland' },
  { code: 'IN', label: 'Indien' },
  { code: 'AE', label: 'Vereinigte Arabische Emirate' },
  { code: 'IL', label: 'Israel' },
];

export const COUNTRY_CODES = COUNTRIES.map(c => c.code);
export const labelFor = (code: string) => COUNTRIES.find(c => c.code === code)?.label ?? code;
